/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* New */
window.themeObj = {
  data: {
    shop: 'unepiece-us.myshopify.com'
  },
  init: function() {
    window.themeObj.templates.collection();

    if (/us.unepiece.com\/en-ca/.test(window.location.href)) {
      window.location.href = 'https://ca.unepiece.com' + window.location.href.replace(/^.*us.unepiece.com\/en-ca(.*)$/, "$1");
    }
  },
  templates: {
    collection: function() {
      const footer = document.querySelector('.boost-pfs-collection-footer');
      const text = document.querySelector('.boost-pfs-collection-footer-text');

      if (footer && text) {
        const textHeight = text.offsetHeight;
        console.log('textHeight', textHeight);

        if (textHeight > 200) {
          footer.classList.add('is-collapsed');

          const textButton = document.querySelector('.boost-pfs-collection-footer-button');

          if (textButton) {
            textButton.addEventListener('click', function() {
              footer.classList.remove('is-collapsed');

              const footerLinks = document.querySelector('.Section__FooterLinks');

              if (footerLinks) {
                footerLinks.removeAttribute('style');
              }
            });
          }
        }
      }
    }
  },
  sections: {}
};

window.themeObj.init();
/* /New */

// ============================================
// FAQ ACCORDION (Product FAQ 3-Tier System)
// Provides smooth height-based animations matching theme.js Collapsible pattern
// and accordion behavior (only one item open at a time)
// ============================================
(function() {
  var ANIMATION_DURATION = 350; // Match theme's 0.35s

  function initFaqAccordion() {
    var container = document.querySelector('.Faq--tiered');
    if (!container) return;

    var items = container.querySelectorAll('details.Faq__Item');

    items.forEach(function(details) {
      var summary = details.querySelector('summary');
      var inner = details.querySelector('.Collapsible__Inner');

      if (!summary || !inner) return;

      // Prevent default toggle and handle manually
      summary.addEventListener('click', function(e) {
        e.preventDefault();

        var isOpen = details.hasAttribute('open');

        if (isOpen) {
          // Close this item
          closeItem(details, inner);
        } else {
          // Close all other open items first (accordion behavior)
          items.forEach(function(otherDetails) {
            if (otherDetails !== details && otherDetails.hasAttribute('open')) {
              var otherInner = otherDetails.querySelector('.Collapsible__Inner');
              closeItem(otherDetails, otherInner);
            }
          });
          // Open this item
          openItem(details, inner);
        }
      });
    });
  }

  function openItem(details, inner) {
    var summary = details.querySelector('summary');

    // Set open attribute first so content is in DOM for measurement
    details.setAttribute('open', '');
    if (summary) summary.setAttribute('aria-expanded', 'true');

    // Get the target height
    var content = inner.querySelector('.Collapsible__Content');
    var targetHeight = content ? content.offsetHeight : inner.scrollHeight;

    // Start from 0
    inner.style.height = '0px';
    inner.style.overflow = 'hidden';
    inner.style.visibility = 'visible';

    // Force reflow
    inner.offsetHeight;

    // Animate to target height
    inner.style.transition = 'height ' + ANIMATION_DURATION + 'ms ease-in-out';
    inner.style.height = targetHeight + 'px';

    // After animation, set to auto for flexible content
    var onEnd = function(e) {
      if (e.propertyName === 'height') {
        inner.style.height = 'auto';
        inner.style.overflow = '';
        inner.removeEventListener('transitionend', onEnd);
      }
    };
    inner.addEventListener('transitionend', onEnd);
  }

  function closeItem(details, inner) {
    var summary = details.querySelector('summary');

    // Set aria-expanded immediately so plus icon animation starts right away
    // (CSS targets [aria-expanded="true"], not [open])
    if (summary) summary.setAttribute('aria-expanded', 'false');

    // Get current height
    var currentHeight = inner.scrollHeight;
    inner.style.height = currentHeight + 'px';
    inner.style.overflow = 'hidden';

    // Force reflow
    inner.offsetHeight;

    // Animate to 0
    inner.style.transition = 'height ' + ANIMATION_DURATION + 'ms ease-in-out';
    inner.style.height = '0px';

    // After animation, remove open attribute and clean up
    var onEnd = function(e) {
      if (e.propertyName === 'height') {
        details.removeAttribute('open');
        inner.style.height = '';
        inner.style.overflow = '';
        inner.style.visibility = '';
        inner.style.transition = '';
        inner.removeEventListener('transitionend', onEnd);
      }
    };
    inner.addEventListener('transitionend', onEnd);
  }

  // Initialize on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();
// ===== END FAQ ACCORDION =====

// ============================================
// LIVE SOLD-OUT SIZE STRIKETHROUGH
// Re-checks which sizes are in stock (by quantity) every time ANY other
// option (e.g. colour) is switched, and toggles the strikethrough live,
// without a page reload. Works off the product JSON already embedded on
// the page by snippets/product-data.liquid (no extra network request).
// ============================================
(function () {
  var SIZE_NAMES = ['size', 'taille', 'größe', 'tamanho', 'tamaño', 'koko', 'サイズ'];

  function isSizeOptionName(name) {
    var lower = (name || '').toLowerCase();
    if (SIZE_NAMES.indexOf(lower) !== -1) return true;

    // Bundle products name their size options compound, e.g.
    // "Lace Trim V-Neck Nightie - Size", so also match anything ending
    // in " - Size" (or the other language equivalents).
    return SIZE_NAMES.some(function (sizeWord) {
      return lower.endsWith(' - ' + sizeWord);
    });
  }

  function getProductData(form) {
    var script = form.querySelector('[data-product-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent).product;
    } catch (error) {
      return null;
    }
  }

  function refreshSizeAvailability(form) {
    var product = getProductData(form);
    if (!product || !product.options || !product.variants) return;

    // Work out which option position(s) (1-based) are "Size" options. Most
    // products have exactly one, but bundle products can have two (one per
    // bundled item, e.g. "Lace Trim V-Neck Nightie - Size" and "Lace Trim
    // Modal Robe - Size") - each is refreshed independently so switching
    // either selector live-updates both sets of swatches.
    var sizePositions = [];

    product.options.forEach(function (name, index) {
      if (isSizeOptionName(name)) sizePositions.push(index + 1);
    });

    if (!sizePositions.length) return;

    sizePositions.forEach(function (sizePosition) {
      var optionWrapper = form.querySelector('.ProductForm__Option[data-option-position="' + sizePosition + '"]');
      if (!optionWrapper) return;

      // Work out the currently selected value for every OTHER option that
      // ISN'T itself a size option (e.g. a real colour option). Bundle
      // products have two independent size options (one per bundled item),
      // so we deliberately don't cross-filter one against the other -
      // otherwise picking a Robe size that happens to be out of stock in
      // combination with a given Nightie size would wrongly cross out that
      // Nightie size too, even though it's available with other Robe sizes.
      var selectedByPosition = {};

      product.options.forEach(function (name, index) {
        var position = index + 1;
        if (sizePositions.indexOf(position) !== -1) return;

        var checked = form.querySelector('.ProductForm__Option[data-option-position="' + position + '"] input:checked');
        if (checked) selectedByPosition[position] = checked.value;
      });

      var sizeInputs = optionWrapper.querySelectorAll('input.SizeSwatch__Radio');

      sizeInputs.forEach(function (input) {
        var value = input.value;

        var available = product.variants.some(function (variant) {
          if (variant['option' + sizePosition] !== value) return false;

          for (var position in selectedByPosition) {
            if (variant['option' + position] !== selectedByPosition[position]) return false;
          }

          // Quantity-based availability: untracked inventory = always available,
          // otherwise the variant needs at least 1 unit in stock
          if (!variant.inventory_management) return true;
          if (variant.inventory_quantity > 0) return true;

          // Out of physical stock, but "continue selling when out of stock" is
          // on for this variant - this is how the Stoq pre-order app keeps it
          // purchasable (e.g. the boxy tee currently on pre-order).
          return variant.inventory_policy === 'continue';
        });

        // Intentionally NOT disabling the input: sizes stay clickable even when
        // sold out, since customers can still select them to join the waitlist
        // or (for backorder-enabled variants) add to cart.
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.classList.toggle('SizeSwatch--soldOut', !available);
      });
    });
  }

  function init() {
    document.querySelectorAll('form.ProductForm').forEach(function (form) {
      refreshSizeAvailability(form);

      form.addEventListener('change', function (event) {
        if (event.target.matches && event.target.matches('.ProductForm__Variants input[type="radio"]')) {
          refreshSizeAvailability(form);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
// ===== END LIVE SOLD-OUT SIZE STRIKETHROUGH =====
